import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import { fireUIAnalytics } from '@atlassian/analytics-bridge';

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import { useHeartbeatsContext } from '../../../controllers/providers/heartbeats';

import messages from './messages';

export const CreateButton = () => {
	const { formatMessage } = useIntl();
	const { focusState } = useHeartbeatsContext();

	return (
		<Button
			appearance="primary"
			onClick={(_, analyticsEvent) => {
				fireUIAnalytics(analyticsEvent, 'createHeartbeatButton');

				focusState.open({ mode: 'create' });
			}}
		>
			{formatMessage(messages.createHeartbeatButton)}
		</Button>
	);
};
